module.exports = __webpack_public_path__ + "static/media/icon_back.6596d558.svg";